import { createSlice } from "@reduxjs/toolkit";

interface MySliceState {
    bg: number,
    lang: string,
    morning: boolean,
    dialogOpen: boolean,
    logOpen: number,
    homeReady: boolean,
    height: number
    mobileOpened: boolean
    userType: boolean,
    language: string,
}
// const getInitialLanguage = () => {
//     if (typeof window !== "undefined") {
//         return localStorage.getItem("preferredLanguage") ?? "en";
//     }
//     return "en"; // Default for SSR
// }
const sysSlice = createSlice({
    name: "sys",
    initialState: { 
        bg: 0,
        lang: "ltr",
        dialogOpen: false,
        logOpen: 7,
        homeReady:false,
        height:200,
        mobileOpened:false,
        userType:true,
        language: typeof window !== "undefined" ? localStorage.getItem("preferredLanguage") ?? "en" : "en"
    } as MySliceState,
    reducers: {
        setLangMy: (state, action) => { state.language = action.payload },
        setHeight: (state, action) => { state.height = action.payload },
        setBg: (state, action) => { state.bg = action.payload },
        setLang: (state, action) => { state.lang = action.payload },
        setDay: (state) => { state.morning = true },
        setNight: (state) => { state.morning = false },
        logAction: (state, action) => { state.logOpen = action.payload },
        setDialog: (state, action) => { state.dialogOpen = action.payload },
        setMobile: (state, action) => { state.mobileOpened = action.payload },
        setUserType: (state, action) => { state.userType = action.payload },
    }
});

export const {setHeight, setLangMy, setUserType, setMobile, logAction, setBg, setLang, setDay, setNight, setDialog} = sysSlice.actions;
export default sysSlice;